import { CSSProperties } from 'react';

import { ReactComponent as AstronautX } from '@backrs_ui/common-ui/src/assets/images/astronaut-x.svg';
import { ReactComponent as BackrsFilledDropShadow } from '@backrs_ui/common-ui/src/assets/images/backrs-filled-drop-shadow.svg';
import { ReactComponent as BackrsLogoSmall } from '@backrs_ui/common-ui/src/assets/images/backrs-logo-small.svg';
import { ReactComponent as BackrsWithText } from '@backrs_ui/common-ui/src/assets/images/backrs-with-text.svg';
import { ReactComponent as BlueprintTextOnly } from '@backrs_ui/common-ui/src/assets/images/blueprint-text-only.svg';
import { ReactComponent as IconApply } from '@backrs_ui/common-ui/src/assets/images/icon-apply.svg';
import { ReactComponent as IconArrowOpenRight } from '@backrs_ui/common-ui/src/assets/images/icon-arrow-open-right.svg';
import { ReactComponent as IconArrowOut } from '@backrs_ui/common-ui/src/assets/images/icon-arrow-out.svg';
import { ReactComponent as IconArrowRight } from '@backrs_ui/common-ui/src/assets/images/icon-arrow-right.svg';
import { ReactComponent as IconArticle } from '@backrs_ui/common-ui/src/assets/images/icon-article.svg';
import { ReactComponent as IconAudio } from '@backrs_ui/common-ui/src/assets/images/icon-audio.svg';
import { ReactComponent as IconBook } from '@backrs_ui/common-ui/src/assets/images/icon-book.svg';
import { ReactComponent as IconBookmarkFilled } from '@backrs_ui/common-ui/src/assets/images/icon-bookmark-filled.svg';
import { ReactComponent as IconBookmark } from '@backrs_ui/common-ui/src/assets/images/icon-bookmark.svg';
import { ReactComponent as IconBriefcase } from '@backrs_ui/common-ui/src/assets/images/icon-briefcase.svg';
import { ReactComponent as IconBuilding } from '@backrs_ui/common-ui/src/assets/images/icon-building.svg';
import { ReactComponent as IconBusOff } from '@backrs_ui/common-ui/src/assets/images/icon-bus-off.svg';
import { ReactComponent as IconBusiness } from '@backrs_ui/common-ui/src/assets/images/icon-business.svg';
import { ReactComponent as IconChecked } from '@backrs_ui/common-ui/src/assets/images/icon-checked.svg';
import { ReactComponent as IconClipboardPlus } from '@backrs_ui/common-ui/src/assets/images/icon-clipboard-plus.svg';
import { ReactComponent as IconClipboard } from '@backrs_ui/common-ui/src/assets/images/icon-clipboard.svg';
import { ReactComponent as IconClose } from '@backrs_ui/common-ui/src/assets/images/icon-close.svg';
import { ReactComponent as IconComingSoon } from '@backrs_ui/common-ui/src/assets/images/icon-coming-soon.svg';
import { ReactComponent as IconCopy } from '@backrs_ui/common-ui/src/assets/images/icon-copy.svg';
import { ReactComponent as IconDocument } from '@backrs_ui/common-ui/src/assets/images/icon-document.svg';
import { ReactComponent as IconDownChevronCircle } from '@backrs_ui/common-ui/src/assets/images/icon-down-chevron-circle.svg';
import { ReactComponent as IconDownload } from '@backrs_ui/common-ui/src/assets/images/icon-download.svg';
import { ReactComponent as IconDropdown } from '@backrs_ui/common-ui/src/assets/images/icon-dropdown.svg';
import { ReactComponent as IconEdit } from '@backrs_ui/common-ui/src/assets/images/icon-edit.svg';
import { ReactComponent as IconEvent } from '@backrs_ui/common-ui/src/assets/images/icon-event.svg';
import { ReactComponent as IconFlag } from '@backrs_ui/common-ui/src/assets/images/icon-flag.svg';
import { ReactComponent as IconGear } from '@backrs_ui/common-ui/src/assets/images/icon-gear.svg';
import { ReactComponent as IconGoal } from '@backrs_ui/common-ui/src/assets/images/icon-goal.svg';
import { ReactComponent as IconHashtag } from '@backrs_ui/common-ui/src/assets/images/icon-hashtag.svg';
import { ReactComponent as IconHeadshot } from '@backrs_ui/common-ui/src/assets/images/icon-headshot.svg';
import { ReactComponent as IconHistory } from '@backrs_ui/common-ui/src/assets/images/icon-history.svg';
import { ReactComponent as IconInstitution } from '@backrs_ui/common-ui/src/assets/images/icon-institution.svg';
import { ReactComponent as IconLevelOne } from '@backrs_ui/common-ui/src/assets/images/icon-level-one.svg';
import { ReactComponent as IconLevelTwo } from '@backrs_ui/common-ui/src/assets/images/icon-level-two.svg';
import { ReactComponent as IconLineArrowLeft } from '@backrs_ui/common-ui/src/assets/images/icon-line-arrow-left.svg';
import { ReactComponent as IconLineArrowRight } from '@backrs_ui/common-ui/src/assets/images/icon-line-arrow-right.svg';
import { ReactComponent as IconList } from '@backrs_ui/common-ui/src/assets/images/icon-list.svg';
import { ReactComponent as IconMap } from '@backrs_ui/common-ui/src/assets/images/icon-map.svg';
import { ReactComponent as IconMessageExclamationMark } from '@backrs_ui/common-ui/src/assets/images/icon-message-exclamation-mark.svg';
import { ReactComponent as IconOfficeChairPlus } from '@backrs_ui/common-ui/src/assets/images/icon-office-chair-plus.svg';
import { ReactComponent as IconOfficeChair } from '@backrs_ui/common-ui/src/assets/images/icon-office-chair.svg';
import { ReactComponent as IconOpportunity } from '@backrs_ui/common-ui/src/assets/images/icon-opportunity.svg';
import { ReactComponent as IconPaperRole } from '@backrs_ui/common-ui/src/assets/images/icon-paper-role.svg';
import { ReactComponent as IconPlayButton } from '@backrs_ui/common-ui/src/assets/images/icon-play-button.svg';
import { ReactComponent as IconPlusBlue } from '@backrs_ui/common-ui/src/assets/images/icon-plus-sign.svg';
import { ReactComponent as IconPlusWhiteBlueCircle } from '@backrs_ui/common-ui/src/assets/images/icon-plus-white-blue-circle.svg';
import { ReactComponent as IconProfileExternal } from '@backrs_ui/common-ui/src/assets/images/icon-profile-external.svg';
import { ReactComponent as IconProfileInternal } from '@backrs_ui/common-ui/src/assets/images/icon-profile-internal.svg';
import { ReactComponent as IconQuestionMark } from '@backrs_ui/common-ui/src/assets/images/icon-question-mark.svg';
import { ReactComponent as IconQuotationLarge } from '@backrs_ui/common-ui/src/assets/images/icon-quotation-large.svg';
import { ReactComponent as IconRefresh } from '@backrs_ui/common-ui/src/assets/images/icon-refresh.svg';
import { ReactComponent as IconScholarship } from '@backrs_ui/common-ui/src/assets/images/icon-scholarship.svg';
import { ReactComponent as IconSearch } from '@backrs_ui/common-ui/src/assets/images/icon-search.svg';
import { ReactComponent as IconSend } from '@backrs_ui/common-ui/src/assets/images/icon-send.svg';
import { ReactComponent as IconSupercoach } from '@backrs_ui/common-ui/src/assets/images/icon-supercoach.svg';
import { ReactComponent as IconSuperuser } from '@backrs_ui/common-ui/src/assets/images/icon-superuser.svg';
import { ReactComponent as IconTextResponse } from '@backrs_ui/common-ui/src/assets/images/icon-text-response.svg';
import { ReactComponent as IconTrainTrack } from '@backrs_ui/common-ui/src/assets/images/icon-train-track.svg';
import { ReactComponent as IconTwoArrows } from '@backrs_ui/common-ui/src/assets/images/icon-two-arrows.svg';
import { ReactComponent as IconUnchecked } from '@backrs_ui/common-ui/src/assets/images/icon-unchecked.svg';
import { ReactComponent as IconUncompleted } from '@backrs_ui/common-ui/src/assets/images/icon-uncompleted.svg';
import { ReactComponent as IconUniversity } from '@backrs_ui/common-ui/src/assets/images/icon-university.svg';
import { ReactComponent as IconUpload } from '@backrs_ui/common-ui/src/assets/images/icon-upload.svg';
import { ReactComponent as IconVideo } from '@backrs_ui/common-ui/src/assets/images/icon-video.svg';
import { ReactComponent as LubavBubble } from '@backrs_ui/common-ui/src/assets/images/lubav-bubble.svg';
import { ReactComponent as LubavFilledDropShadow } from '@backrs_ui/common-ui/src/assets/images/lubav-filled-drop-shadow.svg';
import { ReactComponent as LubavLogoWithText } from '@backrs_ui/common-ui/src/assets/images/lubav-logo-with-text.svg';
import { ReactComponent as LubavLogo } from '@backrs_ui/common-ui/src/assets/images/lubav-logo.svg';
import { ReactComponent as ModuleLevelOne } from '@backrs_ui/common-ui/src/assets/images/module-level-one.svg';
import { ReactComponent as ModuleLevelTwo } from '@backrs_ui/common-ui/src/assets/images/module-level-two.svg';
import { ReactComponent as ModuleUncompleted } from '@backrs_ui/common-ui/src/assets/images/module-uncompleted.svg';
import { ReactComponent as MyAccountLogo } from '@backrs_ui/common-ui/src/assets/images/my-account-logo.svg';
import { ReactComponent as IconPhone } from '@backrs_ui/common-ui/src/assets/images/phone_call_fill.svg';
import { ReactComponent as IconPlusWhite } from '@backrs_ui/common-ui/src/assets/images/plus.svg';
import { ReactComponent as ProsperFilledDropShadow } from '@backrs_ui/common-ui/src/assets/images/prosper-filled-drop-shadow.svg';
import { ReactComponent as ProsperLogo } from '@backrs_ui/common-ui/src/assets/images/prosper-logo.svg';
import { ReactComponent as IconSolutionSession } from '@backrs_ui/common-ui/src/assets/images/solution-session-icon.svg';
import { ReactComponent as CollegeShortlistIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/college_shortlist.svg';
import { ReactComponent as CommonThreadsIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/common_threads.svg';
import { ReactComponent as ImproveYourTestScoresIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/improve_your_test_scores.svg';
import { ReactComponent as JobsYouMightLoveIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/jobs_you_might_love.svg';
import { ReactComponent as LettersOfRecommendationIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/letters_of_rec.svg';
import { ReactComponent as LowerCostOfCollegeIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/lower_cost_of_college.svg';
import { ReactComponent as WhatAreYourChancesIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/what_are_your_chances.svg';
import { ReactComponent as IconUserSwitch } from '@backrs_ui/common-ui/src/assets/images/user-switch.svg';

export const BackrsIconMap = {
  AstronautX,
  IconApply,
  IconArticle,
  IconAudio,
  IconArrowRight,
  IconArrowOpenRight,
  IconArrowOut,
  IconBusiness,
  IconBuilding,
  IconBook,
  IconBookmarkFilled,
  IconBookmark,
  IconBusOff,
  IconBriefcase,
  IconClipboard,
  IconClipboardPlus,
  IconClose,
  IconComingSoon,
  IconCopy,
  IconDocument,
  IconDownChevronCircle,
  IconDropdown,
  IconEvent,
  IconHeadshot,
  IconMessageExclamationMark,
  IconFlag,
  IconGear,
  IconGoal,
  IconHashtag,
  IconHistory,
  IconInstitution,
  IconLineArrowLeft,
  IconLineArrowRight,
  IconList,
  IconMap,
  IconPlayButton,
  IconPaperRole,
  IconOfficeChair,
  IconOfficeChairPlus,
  IconOpportunity,
  IconTrainTrack,
  IconScholarship,
  IconSearch,
  IconSend,
  IconTextResponse,
  IconTwoArrows,
  IconLevelOne,
  IconLevelTwo,
  IconProfileExternal,
  IconProfileInternal,
  IconQuotationLarge,
  IconQuestionMark,
  IconUncompleted,
  IconChecked,
  IconUnchecked,
  IconVideo,
  IconUniversity,
  IconSolutionSession,
  IconPhone,
  IconPlusWhite,
  IconPlusBlue,
  IconPlusWhiteBlueCircle,
  IconUserSwitch,
  BlueprintTextOnly,
  LubavLogoWithText,
  LubavLogo,
  LubavBubble,
  IconSupercoach,
  IconSuperuser,
  ModuleLevelOne,
  LubavFilledDropShadow,
  ModuleLevelTwo,
  ModuleUncompleted,
  ProsperLogo,
  ProsperFilledDropShadow,
  BackrsFilledDropShadow,
  BackrsLogoSmall,
  BackrsWithText,
  MyAccountLogo,
  IconRefresh,
  IconEdit,
  IconDownload,
  IconUpload,
  CollegeShortlistIcon,
  WhatAreYourChancesIcon,
  ImproveYourTestScoresIcon,
  LowerCostOfCollegeIcon,
  JobsYouMightLoveIcon,
  CommonThreadsIcon,
  LettersOfRecommendationIcon,
} as const;

export type BackrsIcons = keyof typeof BackrsIconMap;

type BackrsImageProps = Readonly<{
  color?: string;
  name: BackrsIcons;
  alt: string;
  opacity?: number;
  height?: number;
  width?: number;
  style?: CSSProperties;
}>;

const ICON_TYPES: Record<BackrsIcons, React.FunctionComponent<React.SVGProps<SVGSVGElement>>> = {
  AstronautX,
  IconApply,
  IconArticle,
  IconAudio,
  IconArrowRight,
  IconArrowOpenRight,
  IconArrowOut,
  IconBook,
  IconBookmarkFilled,
  IconBookmark,
  IconBuilding,
  IconBusiness,
  IconBusOff,
  IconBriefcase,
  IconClipboard,
  IconClipboardPlus,
  IconClose,
  IconComingSoon,
  IconCopy,
  IconDownChevronCircle,
  IconDocument,
  IconDropdown,
  IconEvent,
  IconFlag,
  IconMessageExclamationMark,
  IconGoal,
  IconGear,
  IconHeadshot,
  IconHashtag,
  IconHistory,
  IconInstitution,
  IconLineArrowLeft,
  IconLineArrowRight,
  IconList,
  IconMap,
  IconOfficeChair,
  IconOfficeChairPlus,
  IconPlayButton,
  IconPaperRole,
  IconPlusBlue,
  IconPlusWhiteBlueCircle,
  IconOpportunity,
  IconScholarship,
  IconTrainTrack,
  IconTextResponse,
  IconLevelOne,
  IconLevelTwo,
  IconSearch,
  IconSend,
  IconPhone,
  IconProfileExternal,
  IconProfileInternal,
  IconQuotationLarge,
  IconTwoArrows,
  IconUncompleted,
  IconUnchecked,
  IconQuestionMark,
  IconUniversity,
  IconSupercoach,
  IconSuperuser,
  IconChecked,
  IconVideo,
  IconSolutionSession,
  IconPlusWhite,
  IconUserSwitch,
  BlueprintTextOnly,
  ModuleLevelOne,
  ModuleLevelTwo,
  ModuleUncompleted,
  LubavLogoWithText,
  LubavLogo,
  LubavBubble,
  LubavFilledDropShadow,
  ProsperFilledDropShadow,
  ProsperLogo,
  BackrsFilledDropShadow,
  BackrsLogoSmall,
  BackrsWithText,
  MyAccountLogo,
  IconRefresh,
  IconEdit,
  IconDownload,
  IconUpload,
  CollegeShortlistIcon,
  WhatAreYourChancesIcon,
  ImproveYourTestScoresIcon,
  LowerCostOfCollegeIcon,
  JobsYouMightLoveIcon,
  CommonThreadsIcon,
  LettersOfRecommendationIcon,
} as const;

/**
 * Add additional icons to this component when you are importing SVGs.
 *
 * If you are using a Material UI Icon, please import it directly into your component.
 */
export const BackrsIcon = ({
  name,
  alt,
  color,
  opacity = 1,
  height,
  width,
  style,
}: BackrsImageProps) => {
  const IconComponent = ICON_TYPES[name];

  return (
    <IconComponent
      aria-label={alt}
      color={color}
      opacity={opacity}
      // only add height/width if they are passed in
      // passing in undefined will cause the icon to not use its default size
      {...(height && { height })}
      {...(width && { width })}
      {...(style && { style })}
    />
  );
};
